import { LoadingOutlined } from "@ant-design/icons";
import { Spin as AntdSpin, SpinProps as AntdSpinProps } from "antd";
import { themeColors } from "index";
import React, { CSSProperties } from "react";

export type LoadingSpinProps = {
  iconcolor?: CSSProperties["color"];
} & AntdSpinProps;

const LoadingSpin = ({
  iconcolor,
  style,
  indicator,
  ...props
}: LoadingSpinProps) => {
  return (
    <AntdSpin
      indicator={indicator ? indicator : <LoadingOutlined spin />}
      style={{ color: iconcolor ?? themeColors.default.neutral.dark, ...style }}
      {...props}
    />
  );
};

export default LoadingSpin;
